import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useAuth } from '../../../contexts/AuthContext';
import { useLanguage } from '../../../contexts/LanguageContext';

const AuditsTab = ({ siteId, siteData, audits, onRefresh, isReadOnly = false }) => {
  const { userProfile } = useAuth();
  const { t } = useLanguage();

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'var(--color-success)';
      case 'in_progress': return 'var(--color-accent)';
      case 'draft': return 'var(--color-muted-foreground)';
      default: return 'var(--color-muted-foreground)';
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">{t('auditsInspections')}</h3>
        {(userProfile?.role === 'admin' || userProfile?.role === 'worker') && !isReadOnly && (
          <Button
            size="sm"
            iconName="Plus"
            onClick={() => window.location.href = `/audits-inspections?siteId=${siteId}`}
          >
            {t('newAudit')}
          </Button>
        )}
      </div>
      {audits?.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {audits?.map((audit) => (
            <div key={audit?.id} className="bg-muted/50 rounded-lg border border-border p-4">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-start gap-3 flex-1">
                  <div className="flex items-center justify-center w-10 h-10 bg-background rounded-lg flex-shrink-0">
                    <Icon
                      name="ClipboardCheck"
                      size={20}
                      color={getStatusColor(audit?.status)}
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-medium text-foreground mb-1">{audit?.audit_name}</h4>
                    <p className="text-sm text-muted-foreground mb-2">{t('auditor')}: {audit?.auditor_name}</p>
                  </div>
                </div>
                <span
                  className="px-2 py-1 text-xs font-medium rounded-full capitalize"
                  style={{
                    backgroundColor: `${getStatusColor(audit?.status)}20`,
                    color: getStatusColor(audit?.status)
                  }}
                >
                  {audit?.status?.replace('_', ' ')}
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>{new Date(audit?.audit_date)?.toLocaleDateString()}</span>
                {audit?.overall_result && (
                  <span className="font-medium">{audit?.overall_result}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-muted/50 rounded-lg p-12 border border-border text-center">
          <Icon name="ClipboardCheck" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h4 className="text-lg font-semibold text-foreground mb-2">{t('noAuditsConducted')}</h4>
          <p className="text-sm text-muted-foreground mb-4">{t('noAuditsDesc')}</p>
          {(userProfile?.role === 'admin' || userProfile?.role === 'worker') && !isReadOnly && (
            <Button
              size="sm"
              iconName="Plus"
              onClick={() => window.location.href = `/audits-inspections?siteId=${siteId}`}
            >
              {t('newAudit')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default AuditsTab;